import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { Download } from 'react-bootstrap-icons';
import { fixTimezoneOffsetYYYYMMDDWithTimeStamp } from '../../constants/constants';
import { useStore } from '../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import { ITeplarFile } from '../../models/response/ITeplarResponse';
import { NOHistoryIcon } from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import IPageInfo, { IPageLimitInfo } from '../../models/ICommon';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import S3Pagination from '../../shared-components/Grid/S3Pagination';

const TeplarPrintFilesHistoryDetails = () => {
  const { teplarPrintStore, preferencesStore } = useStore();
  const {
    GetTeplarFilesHistoryService,
    teplarFilesHistory,
    teplarList,
    teplarFiles,
    getTeplarFilesHistoryState,
  } = teplarPrintStore;

  const { userSetting, setUserSetting } = preferencesStore;

  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
    // GetTeplarFilesHistoryService(Number(getTenantIdFromLocalStorage()), localStorage.getItem('teplarHistoryToken'))
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    // pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const teplar: ITeplarFile[] = teplarFilesHistory;

  useEffect(() => {
    GetTeplarFilesHistoryService({
      TenantId : Number(getTenantIdFromLocalStorage()),
      ContinuationToken: null
  });
  }, [GetTeplarFilesHistoryService]);

  useEffect(() => {
    if (getTeplarFilesHistoryState.success) {
      localStorage.setItem(
        'teplarHistoryToken',
        teplarFiles.PagingDetail.ContinuationToken
      );
    }
  }, [getTeplarFilesHistoryState.success]);

  return (
    <>
      {teplar && teplar.length > 0 ? (
        <>
        <div className='teplar-history-table-pannle'>
          <Table
            className="download-print border"
            bordered
            hover
            responsive
          >
            <thead>
              <tr>
                <th>{formatMessage('date')}</th>
                <th style={{ textAlign: 'center' }}>
                  {formatMessage('download')}
                </th>
              </tr>
            </thead>
            <tbody>
              {teplar.map((file, idx) => (
                <tr key={idx}>
                  <td>
                    {fixTimezoneOffsetYYYYMMDDWithTimeStamp(file.LastChange)}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <a
                      className="download-print-icon"
                      href={file.FilePath}
                      download={file.FileName}
                    >
                      <Download size={18} />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          </div>

          {/* ✅ Pagination block */}
          <div className="row no-gutters p-3 pt-0 tableFooter">
            <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
              <S3Pagination
                isRefreshPage={false}
                totalPages={pageInfo?.totalPages ?? 0}
                pageLimit={pageLimitInfo?.pageLimit ?? 10}
                onPageChanged={onPageChanged}
                disablePagination={disablePagination}
                setIsRefreshPage={setIsRefreshPage}
                currentPage={pageInfo?.currentPage ?? 1}
                totalRecords={teplarFiles?.PagingDetail?.TotalRecords ?? 0}
                continuationToken={
                  teplarFiles?.PagingDetail?.ContinuationToken ?? ''
                }
                getTeplarFileHistoryService={(token?: string) =>
                  GetTeplarFilesHistoryService({
                    TenantId: Number(getTenantIdFromLocalStorage()),
                    ContinuationToken: token ?? null,
                  })
                }
                pageRecord={teplarFiles?.PagingDetail?.PageRecord}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="no-data-history message">
          <NOHistoryIcon />
          <h3 className="fw-bold display-6">
            {formatMessage('no_history_message')}
          </h3>
        </div>
      )}
    </>
  );
};

export default observer(TeplarPrintFilesHistoryDetails);
